<!-- WIDOK DESKTOP -->

<ion-row
  class="content"
  *ngIf="!displayMobileView"
  routerLink="/app/invitation/edit-invitation/{{
    row.qrcode.invitationGuest.idInvitation
  }}"
>
  <ion-col size="4" size-xl="3">
    {{ row.date | dateSti }}

    <ng-container *ngIf="showTimeStampPermamently">
      <ion-chip color="primary" *ngIf="timeStamp">
        <ion-label> {{ timeStamp }}</ion-label>
        <ion-icon
          name="close-circle"
          (click)="onHideTimeStamp($event)"
        ></ion-icon>
      </ion-chip>
    </ng-container>
  </ion-col>
  <ion-col size="1">
    {{
      companyServ.getCompanyName(
        row.qrcode.invitationGuest.invitation.user.idCompany
      )
    }}
  </ion-col>
  <ion-col size="2">
    {{ row.qrcode.invitationGuest.invitation.user.firstName }}
    {{ row.qrcode.invitationGuest.invitation.user.lastName }}
  </ion-col>
  <ion-col size="2">
    {{ row.qrcode.invitationGuest.fullname }}
  </ion-col>
  <ion-col size="3" size-xl="4">
    {{ row.qrcode.invitationGuest.invitation.dateStart | dateSti }}
    -
    {{ row.qrcode.invitationGuest.invitation.dateEnd | dateSti: "onlyHour" }}
  </ion-col>
</ion-row>

<!-- WIDOK MOBILNY -->

<ion-card
  *ngIf="displayMobileView"
  class="content-card-noborder"
  routerLink="/app/invitation/edit-invitation/{{
    row.qrcode.invitationGuest.idInvitation
  }}"
>
  <ion-card-header>
    <ion-card-title>{{
      companyServ.getCompanyName(
        row.qrcode.invitationGuest.invitation.user.idCompany
      )
    }}</ion-card-title>
    <ion-card-subtitle>
      <ion-grid>
        <ion-row>
          <ion-col size-sm="9" size-xs="12">
            {{ row.qrcode.invitationGuest.invitation.user.firstName }}
            {{ row.qrcode.invitationGuest.invitation.user.lastName }}
          </ion-col>
          <ion-col size-sm="3" size-xs="12" *ngIf="showTimeStampPermamently">
            <ion-chip color="primary" *ngIf="timeStamp">
              <ion-label> {{ timeStamp }}</ion-label>
              <ion-icon
                name="close-circle"
                (click)="onHideTimeStamp($event)"
              ></ion-icon>
            </ion-chip>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-card-subtitle>
  </ion-card-header>

  <ion-card-content>
    <ion-grid class="no-padding-grid invitation-mobile">
      <ion-row>
        <ion-col size-sm="4" size-xs="12">
          <ion-icon mobile src="assets/icons/clock.svg"></ion-icon>
          <ion-text class="inv-info"> {{ row.date | dateSti }}</ion-text>
        </ion-col>
        <ion-col size-sm="5" size-xs="12">
          <ion-icon mobile src="assets/icons/calendar-gray.svg"></ion-icon>
          <ion-text class="inv-info"
            >{{ row.qrcode.invitationGuest.invitation.dateStart | dateSti }}
            -
            {{
              row.qrcode.invitationGuest.invitation.dateEnd
                | dateSti: "onlyHour"
            }}</ion-text
          >
        </ion-col>
        <ion-col size-sm="3" size-xs="12">
          <ion-icon mobile src="assets/icons/people.svg"></ion-icon>
          <ion-text mobile class="inv-info">
            {{ row.qrcode.invitationGuest.fullname }}
          </ion-text>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-card-content>
</ion-card>
